import NamesJSON from 'names.json'
import { INamesJSON } from './SuggestionHandlerProps'
import { SessionStorage } from 'common/CookieStorage'
import { STORAGEKEYS } from 'enviroment/Keys'
import { ILocationsModels } from '../OnBlurHandlers/OnBlurHandlersProps'


/**
 * Funkcja zwracająca tablicę wszystkich autosugestii dotyczących imion
 * 
 * Pobieramy obiekt imion z pliku names.json, po czym filtrujemy go względem tekstu wpisywanego przez użytkownika w kontrolkę.
 * Następnie sortujemy wyniki względem parametru "Occurences" który reprezentuje ilość wystąpień danego imienia -
 * - im większa jego wartość, tym imię częściej występuje.
 * 
 * @returns Tablica stringów, gdzie każdy string reprezentuje dane imię ze słonwika imion
 */
export const getNamesSuggestions = (currentInputValue: string): string[] => {
   if(currentInputValue.length >= 2) {
      const currentOptions: string[] = NamesJSON.Names
      .filter((currentNameOption: INamesJSON) =>  // Filtrujemy słownik wszystkich imion i wyszukujemy w nim te które zaczynają się od liter wpisanych przez użytkownika
         currentNameOption.FirstName.toLowerCase().startsWith(currentInputValue.toLowerCase())
      )
      .sort((a: INamesJSON, b: INamesJSON) => { // Sortujemy przefiltrowaną tablicę po parametrze `Occurences`, im większa wartość, tym imię wyżej
         const aOccurencesNumber = parseInt(a.Occurences)  || 0
         const bOccurencesNumber = parseInt(b.Occurences)  || 0
         return bOccurencesNumber + aOccurencesNumber 
      })
      .map((currentNameOption: INamesJSON) => currentNameOption.FirstName.toLowerCase()) // Mapujemy na tablicę stringów, tak aby wyświetlić ją jako opcje w komponencie autocomplete 

      return currentOptions
   }
   else return []
}


/**
 * Funkcja zwracająca tablicę wszystkich autosugestii dotyczących nazw miast dla danego kodu pocztowego
 * 
 * Na podstawie wartości wpisanej w kontrolkę "Kod pocztowy", pobierana jest tablica wszystkich miast związanych z danym kodem,
 * po czym filtrowana jest względem tekstu wpisywanego przez użytkownika w kontrolkę.
 * 
 * @returns Tablica stringów, gdzie każdy string reprezentuje dane miasto związane z danym kodem pocztowym
 */
export const getCitySuggestions = (currentInputValue: string): string[] => {
   const sessionStorage = new SessionStorage()
   const locations: ILocationsModels[] = JSON.parse(sessionStorage.get(STORAGEKEYS.LOCATIONS))

   if(locations && locations.length > 0) {
     const currentOptions: string[] = locations
     .map(location => location.city)
     .filter(location => location.toLowerCase().startsWith(currentInputValue.toLowerCase()))
     
     return currentOptions.sort()
   }
   else {
      return []
   }
}

/**
 * Funkcja zwracająca tablicę wszystkich autosugestii dotyczących nazw ulic. 
 * 
 * Na podstawie wartości zapisanej w kontrolce "Miasto", pobierana jest tablica wszystkich ulic dla danego miasta,
 * po czym jest filtrowana względem tekstu wpisywanego przez użytkownika w kontrolkę.
 * @returns Tablica stringów, gdzie każdy string reprezentuje daną ulicę dla danego miasta
 */
export const getStreetSuggestions = (currentInputValue: string): string[] => {
   const sessionStorage = new SessionStorage()
   const currentSelectedCityValue: string = sessionStorage.get(STORAGEKEYS.CURRENT_CITY_VALUE) ?? ''
   const locations: ILocationsModels[] = JSON.parse(sessionStorage.get(STORAGEKEYS.LOCATIONS))
   
   if(currentSelectedCityValue.length > 0){
      const currentSelectedCity: string[] = locations
      .filter(location => location.city.trim().toLowerCase() === currentSelectedCityValue.trim().toLowerCase())[0]?.streets ?? [] // Jeśli nie znajdziemy pasującego miasta, zwracamy pustą tablicę

      if(currentInputValue && currentSelectedCity.length > 0) {
         const currentStreetOptions: string[] = currentSelectedCity.filter(street => street?.toLowerCase().startsWith(currentInputValue?.toLowerCase() ?? false))

         return currentStreetOptions.sort()
      }
      else {
         return []
      }
   }
   else {
      return []
   }
}